export const TITLE = {
	DELETE_PICKUP: 'Delete pickup',
	DELETE_DELIVERY: 'Delete delivery',
	REMOVE_PAYMENT: 'Remove payment',
	REMOVE_NOTES: 'Remove note',
	REMOVE_FILES: 'Remove file',
	REMOVE_LOAD: 'Remove load',
	REMOVE_TRIP: 'Remove trip',
	REMOVE_SCHEDULE: 'Remove schedule',
	REMOVE_BILLING_INVOICED: 'Remove invoiced',
	REMOVE_PPW_FILE: 'Remove PPW file',
	GUIDE_FILE: 'Files guide',
};
export const TEXT = {
	DELETE_PICKUP: 'Are you sure you want to delete this pickup?',
	DELETE_DELIVERY: 'Are you sure you want to delete this delivery?',
	REMOVE_PAYMENT: 'Are you sure you want to remove this payment?',
	REMOVE_NOTES: 'Are you sure you want to remove this note?',
	REMOVE_FILES: 'Are you sure you want to remove this file?',
	REMOVE_LOAD: 'Are you sure you want to remove this load # ',
	REMOVE_TRIP: 'Are you sure you want to remove this trip # ',
	REMOVE_SCHEDULE: 'Are you sure you want to remove this schedule?',
	REMOVE_BILLING_INVOICED: 'Are you sure you want to remove this invoiced?',
	REMOVE_PPW_FILE: 'Are you sure you want to remove this PPW file?',
	GUIDE_FILE_1: 'Files cannot contain the following characters: & “ < > ? ! # { } % | / \\ ~ * :',
	GUIDE_FILE_2: 'PDF file must be version 1.4.',
};
export const KEY = {
	PICKUP: 'pickup',
	DELIVERY: 'delivery',
	PAYMENT: 'payment',
	NOTE: 'note',
	FILE: 'file',
	LOAD: 'load',
	TRIP: 'trip',
	PAPER_WORK: 'paperWork',
	BILLING_INVOICED: 'billingInvoiced',
	PPW_FILE: 'ppwFile',
};
export const loadType = [
	{
		value: "Full",
		id: 1,
	},
	{
		value: "Partial",
		id: 2,
	},

];
export const paymentsTypes = [
	{
		value: "Detention",
		id: 1,
	},
	{
		value: "Layover",
		id: 2,
	},
	{
		value: "Charge",
		id: 3,
	},
	// {
	// 	name: "Lumper",
	// 	val: 4,
	// },
	{
		value: "Bonus",
		id: 5,
	},
];
export const tablePayments = [
	{
		settings: true,
		text: "Type",
		value: "typeName",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Note",
		value: "msg",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Amount",
		value: "amount",
		func: false,
		filterable: false,
		sortable: true,
		dollar: true
	},
	{
		width: '200px',
		settings: true,
		text: "Include in total gross",
		value: "considerBoolean",
		func: false,
		filterable: false,
		sortable: true,
		isStatus: true,
		align: 'center',
	},
	{
		width: '80px',
		// isRemoveAll: true,
		buttons: [
			{
				perm: true,
				value: 'edit',
				text: 'Edit payment',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete',
				text: 'Delete payment',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		],
	}
];
export const tablePaymentsView = [
	{
		settings: true,
		text: "Type",
		value: "typeName",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Note",
		value: "msg",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Amount",
		value: "amount",
		func: false,
		filterable: false,
		sortable: true,
		dollar: true
	},
	{
		width: '200px',
		settings: true,
		text: "Include in total gross",
		value: "considerBoolean",
		func: false,
		filterable: false,
		sortable: true,
		isStatus: true,
		align: 'center',
	},
	{
		width: '80px',
		// isRemoveAll: true,
		buttons: [
			{
				perm: true,
				value: 'edit',
				text: 'Edit payment',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete',
				text: 'Delete payment',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		],
	}
];
export const tablePaymentsViewCustomer = [
	{
		settings: true,
		text: "Type",
		value: "typeName",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Note",
		value: "msg",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Amount",
		value: "amount",
		func: false,
		filterable: false,
		sortable: true,
		dollar: true
	},
	{
		width: '200px',
		settings: true,
		text: "Include in total gross",
		value: "considerBoolean",
		func: false,
		filterable: false,
		sortable: true,
		isStatus: true,
		align: 'center',
	},
];

export const tableNotes = [
	{
		settings: true,
		text: "Date created",
		value: "created_at",
		func: false,
		sortable: true,
		footer: "count",
		modValue: 'dateTime',
		width: '110px'
	},
	{
		settings: true,
		text: "Date edit",
		value: "edit_at",
		func: false,
		sortable: true,
		modValue: 'dateTime',
		width: '110px'
	},
	{
		settings: true,
		text: "Employee",
		value: "dispatcher_name",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Note",
		value: "comment",
		func: false,
		sortable: true,
	},
	{
		width: '80px',
		buttons: [
			{
				perm: 'del',
				value: 'edit',
				text: 'Edit note',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: 'del',
				value: 'delete',
				text: 'Delete note',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		],
	}
];

export const tableNotesView = [
	{
		settings: true,
		text: "Date created",
		value: "created_at",
		func: false,
		sortable: true,
		footer: "count",
		modValue: 'dateTime',
		width: '110px'
	},
	{
		settings: true,
		text: "Date edit",
		value: "edit_at",
		func: false,
		sortable: true,
		modValue: 'dateTime',
		width: '110px'
	},
	{
		settings: true,
		text: "Employee",
		value: "dispatcher_name",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Note",
		value: "comment",
		func: false,
		sortable: true,
	},
];
export const tableFiles = [
	{
		settings: true,
		text: "Date created",
		value: "created_at",
		func: false,
		sortable: true,
		footer: "count",
		modValue: 'dateTime',
		width: '110px'
	},
	{
		settings: true,
		text: "Employee",
		value: "dispatcher_name",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Type",
		value: "typeName",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "File name",
		value: "description",
		func: false,
		sortable: true,
	},
	{
		width: '80px',
		buttons: [
			{
				perm: true,
				value: 'view',
				text: 'View file',
				icon: { value: 'icon_view', w: 18, h: 14 },
			},
			{
				download: true,
				perm: true,
				value: 'image',
				text: 'Download file',
				icon: { value: 'icon_download', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete',
				text: 'Delete file',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		],
	}
];
export const tableFilesView = [
	{
		settings: true,
		text: "Date created",
		value: "created_at",
		func: false,
		sortable: true,
		footer: "count",
		modValue: 'dateTime',
		width: '110px'
	},
	{
		settings: true,
		text: "Employee",
		value: "dispatcher_name",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Type",
		value: "typeName",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "File name",
		value: "description",
		func: false,
		sortable: true,
	},
	{
		width: '80px',
		buttons: [
			{
				perm: true,
				value: 'view',
				text: 'View file',
				icon: { value: 'icon_view', w: 18, h: 14 },
			},
			{
				download: true,
				perm: true,
				value: 'image',
				text: 'Download file',
				icon: { value: 'icon_download', w: 18, h: 18 },
			},
		],
	}
];
export const tripItemFilesHeader = [
	{
		settings: true,
		text: "Trip ID",
		value: "trip_id",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Load ID",
		value: "load_id",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Date created",
		value: "created_at",
		func: false,
		sortable: true,

		modValue: 'dateTime',
		width: '110px'
	},
	{
		settings: true,
		text: "Employee",
		value: "dispatcher_name",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Type",
		value: "typeName",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "File name",
		value: "description",
		func: false,
		sortable: true,
	},
	{
		width: '80px',
		buttons: [
			{
				perm: true,
				value: 'view',
				text: 'View file',
				icon: { value: 'icon_view', w: 18, h: 14 },
			},
			{
				download: true,
				perm: true,
				value: 'image',
				text: 'Download file',
				icon: { value: 'icon_download', w: 18, h: 18 },
			},
		],
	}
];

export const tablePPWFiles = [
	{ width: '34px', settings: true, isCheckbox: true, isCheckboxAll: true, isCheckboxTotal: true },
	{
		text: "File name",
		value: "name",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "File type",
		value: "type",
		func: false,
		sortable: true,
	},
	{
		width: '44px',
		buttons: [
			{
				perm: true,
				value: 'view',
				text: 'View file',
				icon: { value: 'icon_view', w: 18, h: 14 },
			}
		],
	}
];

export const tableViewPPWFiles = [
	{
		text: "File name",
		value: "name",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "File type",
		value: "type",
		func: false,
		sortable: true,
	},
	{
		width: '44px',
		buttons: [
			{
				perm: true,
				value: 'view',
				text: 'View file',
				icon: { value: 'icon_view', w: 18, h: 14 },
			}
		],
	}
];
